export default "__VITE_ASSET__DGLUFrYF__"